import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 34 37"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "2.475",
      transform: "translate(2 2)"
    }, [
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M10 18.15h13.333c2.852 0 5.251 2.113 5.585 4.916L30 32.175M10 18.15C5.404 17.139 1.779 13.643.637 9.121L0 6.6m10 11.55v8.25c0 3.111 0 4.667.976 5.633.977.967 2.548.967 5.69.967s4.715 0 5.691-.967.976-2.522.976-5.633v-1.65"
      }),
      _createElementVNode("ellipse", {
        cx: "16.667",
        cy: "6.6",
        rx: "6.667",
        ry: "6.6"
      })
    ], -1)
  ]))]))
}
export default { render: render }